/* ==========================================================================
   AntiNRML — perilaku lapisan mobile
   Dimuat defer di semua halaman kecuali '/' (splash bare).

   Tidak ada dependensi. Semua fitur mendegradasi dengan aman:
   • Rail tetap bisa di-scroll jari tanpa JS — dots cuma tambahan.
   • Accordion pakai <details> asli, buka-tutup tanpa JS.
   • Facade video punya <noscript> berisi tautan ke YouTube.
   • Tab Akun tetap tautan biasa ke halaman akun kalau enhancement gagal.
   ========================================================================== */

(function () {
  'use strict';

  /* ---------------------------------------------------------------- RAIL */
  /*
    Titik indikator dibuat dari jumlah anak rail. Posisi aktif dihitung dari
    scrollLeft dibagi lebar satu kartu — bukan dari IntersectionObserver, karena
    snap mandatory sudah menjamin kartu berhenti di kelipatan lebar kartu, dan
    pembagian sederhana jauh lebih murah saat scroll.
  */
  function initRail(rail) {
    var items = Array.prototype.filter.call(rail.children, function (el) {
      return el.nodeType === 1;
    });
    if (items.length < 2) return;

    var dots = document.createElement('div');
    dots.className = 'anr-rail__dots';
    dots.setAttribute('aria-hidden', 'true');

    items.forEach(function (item, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'anr-rail__dot' + (i === 0 ? ' is-active' : '');
      b.setAttribute('aria-label', 'Ke item ' + (i + 1) + ' dari ' + items.length);
      b.addEventListener('click', function () {
        rail.scrollTo({ left: item.offsetLeft - rail.offsetLeft, behavior: 'smooth' });
      });
      dots.appendChild(b);
    });

    rail.insertAdjacentElement('afterend', dots);

    var buttons = Array.prototype.slice.call(dots.children);
    var ticking = false;

    function sync() {
      ticking = false;
      var step = items[1].offsetLeft - items[0].offsetLeft;
      if (!step) return;
      var idx = Math.round(rail.scrollLeft / step);
      if (idx < 0) idx = 0;
      if (idx > items.length - 1) idx = items.length - 1;
      buttons.forEach(function (b, i) {
        b.classList.toggle('is-active', i === idx);
      });
    }

    rail.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(sync);
      },
      { passive: true }
    );
  }

  /*
    Dots hanya berguna selama rail benar-benar men-scroll. Di >=750px rail
    kembali jadi grid, jadi dots disembunyikan lewat CSS — tapi tetap dibangun
    supaya rotasi layar tidak perlu inisialisasi ulang.
  */
  document.querySelectorAll('[data-anr-rail]').forEach(initRail);

  /* -------------------------------------------------------- FACADE VIDEO */
  /*
    Iframe YouTube menarik ratusan KB sebelum ada yang menekan play. Di sini
    thumbnail statis dulu; iframe baru disisipkan saat diklik, dengan autoplay=1
    supaya klik pertama langsung memutar (satu klik, bukan dua).
  */
  document.querySelectorAll('[data-anr-yt]').forEach(function (el) {
    el.addEventListener('click', function () {
      if (el.classList.contains('is-playing')) return;
      var id = el.getAttribute('data-anr-yt');
      if (!id) return;

      var frame = document.createElement('iframe');
      frame.src =
        'https://www.youtube-nocookie.com/embed/' +
        id +
        '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
      frame.title = el.getAttribute('data-anr-yt-title') || 'Video YouTube';
      frame.allow =
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      frame.setAttribute('allowfullscreen', '');

      el.classList.add('is-playing');
      var img = el.querySelector('img');
      if (img) img.remove();
      el.appendChild(frame);
    });
  });

  /* --------------------------------------------- THUMBNAIL YOUTUBE RUSAK */
  /*
    YouTube TIDAK mengembalikan 404 untuk maxresdefault yang tidak ada — ia
    mengembalikan placeholder abu-abu 120x90 dengan status 200. Artinya `onerror`
    di markup tidak pernah menyala, dan gambar 120px itu direntangkan ke 16:9.
    Satu-satunya penanda yang bisa dipercaya adalah naturalWidth.
    Terbukti kena di video Tenxi (k0ubS6BhHu4) — 1 dari 15, tapi kebetulan yang
    paling depan di roster. Diperiksa 27 Jul: 14 video lain punya maxres 1280px.
  */
  document.querySelectorAll('[data-anr-yt] img').forEach(function (img) {
    function check() {
      if (img.naturalWidth > 0 && img.naturalWidth <= 120 && img.src.indexOf('maxresdefault') > -1) {
        img.src = img.src.replace('maxresdefault', 'hqdefault');
      }
    }
    // Gambar bisa sudah selesai dimuat sebelum script defer ini jalan.
    if (img.complete) check();
    else img.addEventListener('load', check);
  });

  /* ------------------------------------------------------ BADGE KERANJANG */
  /*
    Jumlah awal dirender dari Liquid supaya tidak ada kedipan. Setelah itu
    disegarkan pada dua momen yang benar-benar bisa membuatnya basi:
    • add-to-cart lewat drawer (event custom theme, kalau ada)
    • kembali dari bfcache (tombol back setelah checkout)
  */
  var badge = document.querySelector('[data-anr-cart-count]');

  function refreshCart() {
    if (!badge) return;
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        if (!cart) return;
        badge.textContent = cart.item_count;
        badge.hidden = cart.item_count < 1;
      })
      .catch(function () {
        /* jaringan gagal: biarkan angka lama, jangan dikosongkan */
      });
  }

  if (badge) {
    ['cart:update', 'cart:refresh', 'variant:add'].forEach(function (evt) {
      document.addEventListener(evt, refreshCart);
    });
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) refreshCart();
    });
  }

  /* --------------------------------------------- TAB AKUN → PANEL INLINE */
  /*
    Toko ini memakai new customer accounts, jadi halaman akunnya di-host Shopify
    di origin lain dan TIDAK bisa digayakan. Satu-satunya cara pengguna tetap
    berada di dalam situs adalah komponen <shopify-account>, yang mengekspos
    method publik showModal() untuk membuka panel sign-in inline.

    Dipasang sebagai enhancement, bukan sebagai satu-satunya jalan: href tab tetap
    menunjuk ke halaman akun, jadi kalau komponennya hilang di versi Horizon
    berikutnya, tab Akun tetap berfungsi — cuma kembali berpindah halaman.
  */
  var accountTab = document.querySelector('[data-anr-account-tab]');
  var accountEl = document.querySelector('shopify-account');

  if (accountTab && accountEl && typeof accountEl.showModal === 'function') {
    accountTab.addEventListener('click', function (e) {
      // Hormati buka-di-tab-baru.
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      accountEl.showModal();
    });
  }

  /* ----------------------------------------------- TAP TAB AKTIF = KE ATAS */
  /*
    Konvensi aplikasi: menekan tab yang sedang aktif membawa kembali ke atas
    daftar, bukan memuat ulang halaman.
  */
  document.querySelectorAll('.anr-tabbar__item.is-active[href]').forEach(function (a) {
    if (a.hasAttribute('data-anr-account-tab')) return;
    a.addEventListener('click', function (e) {
      if (window.scrollY < 4) return;
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });
})();
